import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'
import '@vant/touch-emulator'

import VConsole from 'vconsole'

import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'
import { getKeyInfo } from './request/api'
import { getQueryString } from '@/utils/index'
if (
  window.location.href.indexOf('http://192.168') > -1 ||
  window.location.href.indexOf('test.patrol.h5.xiaoqiandao.com') > -1 ||
  window.location.href.indexOf('pre.patrol.h5.xiaoqiandao.com') > -1 ||
  window.location.href.indexOf('debug=1') > -1
) {
  let vConsole = new VConsole({
    target: '#body',
  })
} else {
}

const app = createApp(App)
app.use(router)
// 针对特殊关键字进行默认配置
// let new_token = getQueryString('token')
app.config.globalProperties.KEYS = {
  KEY_STORE_NAME: '门店',
  KEY_RUNING_NAME: '营业中',
  KEY_CLOSE_NAME: '已闭店',
}
window.myVueApp = app
app.mount('#app')
